module.exports = __webpack_public_path__ + "images/02aa4fb459c44bfb9a35b1517ae33b39.png";